import { Button, Card, Flex, Typography } from 'antd';
import { FC, PropsWithChildren, memo } from 'react';

import { EmptyText } from '@/common/components';
import { getDateFactory } from '@/common/utils';

import { DomainDeployStatus } from '@/modules/Domains';
import { DomainsApiProviders } from '@/modules/DomainsApi';

interface Props {
  deployStatus: DomainDeployStatus;
  lastCachePurgedAt: Date;
  apiProvider: DomainsApiProviders | null;
  loading: boolean;
  handlePurgeDomainCache: () => void;
}

export const SiteDomainCachePurging: FC<Props> = memo(
  ({ deployStatus, lastCachePurgedAt, apiProvider, loading, handlePurgeDomainCache }) => {
    if (deployStatus !== DomainDeployStatus.Deployed)
      return (
        <SiteDomainCachePurgingContainer>
          <Typography.Text type="secondary" italic>
            (Недоступно)
          </Typography.Text>
        </SiteDomainCachePurgingContainer>
      );

    if (!apiProvider || apiProvider !== DomainsApiProviders.Cloudflare)
      return (
        <SiteDomainCachePurgingContainer>
          <Typography.Text type="secondary" italic>
            Скидання кешу DNS не підтримується провайдером
          </Typography.Text>
        </SiteDomainCachePurgingContainer>
      );

    return (
      <SiteDomainCachePurgingContainer>
        <Flex justify="space-between" align="center" gap={8}>
          <span>Востаннє: {lastCachePurgedAt ? getDateFactory(lastCachePurgedAt, 'Aug 16, 2018 08:02') : <EmptyText />}</span>

          <Button size="small" type="primary" loading={loading} onClick={handlePurgeDomainCache}>
            Скинути кеш DNS
          </Button>
        </Flex>
      </SiteDomainCachePurgingContainer>
    );
  },
);

const SiteDomainCachePurgingContainer: FC<PropsWithChildren> = ({ children }) => (
  <Card title="Кеш DNS домену" size="small">
    {children}
  </Card>
);
